import React from 'react';
import CIcon from '@coreui/icons-react';
import permissions from '../core/configs/permissions';
import roles from '../core/configs/roles';

export default [
  {
    _tag: 'CSidebarNavItem',
    name: 'Petition Images',
    to: '/viewer',
    icon: <CIcon name="cil-image" customClasses="c-sidebar-nav-icon" />,
    forbiddenInitiativeRoles: [],
    permission: permissions.view_petition_images,
    initiativeMode: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Locations & Events',
    to: '/locations-events',
    icon: <CIcon name="cil-calendar" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.initiativeOrganizer.name,
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
    initiativeSettingKey: 'location_events_enabled',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Landing Pages',
    to: '/landing-pages',
    icon: <CIcon name="cil-notes" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_landing_pages,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
    initiativeMode: true,
    initiativeSettingKey: 'landing_pages',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Manage Prospects',
    to: '/manage-prospects',
    icon: <CIcon name="cil-user" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    initiativeSettingKey: 'manage_prospects_enabled',
    forbiddenInitiativeRoles: [
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Recruits',
    to: '/recruits',
    icon: <CIcon name="cil-comment-square" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    initiativeSettingKey: 'recruits_enabled',
    forbiddenInitiativeRoles: [
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Generate Petitions',
    to: '/generate-petitions',
    icon: <CIcon name="cil-note-add" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_generate_petitions,
    initiativeMode: true,
    initiativeSettingKey: 'generate_petitions',
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.electionOfficialAssignee.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Manage Petitions',
    to: '/manage-petitions',
    icon: <CIcon name="cil-pin" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_assign_petitions,
    initiativeMode: true,
    initiativeSettingKey: 'assign_petitions',
    forbiddenInitiativeRoles: [
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Canvass Routes',
    to: '/canvas-routes',
    icon: <CIcon name="cil-graph" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    forbiddenInitiativeRoles: [
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
    initiativeSettingKey: 'canvass_routes_enabled',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'QA Petitions',
    to: '/qa-petitions',
    icon: <CIcon name="cil-check-circle" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    initiativeSettingKey: 'qa_petitions_section',
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Enter Signatures',
    to: '/enter-signatures',
    icon: <CIcon name="cil-color-border" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_enter_signature_data,
    initiativeMode: true,
    initiativeSettingKey: 'enter_signature',
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Review Petitions',
    to: '/review-petitions',
    icon: <CIcon name="cil-search" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_review_petitions,
    initiativeMode: true,
    initiativeSettingKey: 'review_petitions_enabled',
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Review Audits',
    to: '/audit-queue',
    icon: <CIcon name="cil-tag" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.read_audit,
    initiativeMode: true,
    initiativeSettingKey: 'audit_queue_enabled',
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Review Signatures',
    to: '/review-signatures',
    icon: <CIcon name="cil-notes" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_review_petitions,
    initiativeMode: true,
    initiativeSettingKey: 'review_signatures',
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  // admin-mode-routes
  {
    _tag: 'CSidebarNavItem',
    name: 'Jurisdictions',
    to: '/jurisdictions',
    icon: <CIcon name="cil-short-text" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_jurisdictions,
    adminMode: true,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Organizations',
    to: '/organizations',
    icon: <CIcon name="cil-group" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.update_organization,
    adminMode: true,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Donate Forms',
    to: '/donate-forms',
    icon: <CIcon name="cil-dollar" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_donations,
    adminMode: true,
    initiativeMode: false,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Initiatives',
    to: '/initiatives',
    icon: <CIcon name="cil-notes" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_initiatives,
    adminMode: true,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  // admin-mode-routes (END)
  {
    _tag: 'CSidebarNavItem',
    name: 'Users',
    to: '/users',
    icon: <CIcon name="cil-user" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_users,
    adminMode: true,
    initiativeMode: true,
    forbiddenInitiativeRoles: [
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.electionOfficialAssignee.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Global Settings',
    to: '/global-settings',
    icon: <CIcon name="cil-settings" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.view_global_settings,
    adminMode: true,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Upload & Scan',
    to: '/upload-and-scan',
    icon: <CIcon name="cil-cloud-upload" customClasses="c-sidebar-nav-icon" />,
    permission: permissions.read_uploaded_files,
    initiativeMode: true,
    initiativeSettingKey: 'upload_and_scan_feature',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Reports',
    to: '/reports',
    icon: <CIcon name="cil-bar-chart" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    initiativeSettingKey: 'reports_enabled',
    permission: permissions.view_reports,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.dataAssignee.name,
      roles.auxiliaryTaskSpecialist.name,
      roles.initiativeOrganizer.name,
      roles.initiativeManager.name,
      roles.petitionUploader.name,
      roles.electionOfficialAssignee.name,
    ],
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Admin',
    icon: <CIcon name="cil-settings" customClasses="c-sidebar-nav-icon" />,
    initiativeMode: true,
    adminMode: false,
    permission: [
      permissions.view_settings,
      permissions.create_label,
      permissions.create_category,
      permissions.view_donations,
    ],
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Notification Settings',
        to: '/settings',
        icon: <CIcon name="cil-bell" customClasses="c-sidebar-nav-icon" />,
        permission: permissions.view_settings,
        initiativeMode: true,
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Custom Review Notes',
        permission: permissions.create_category,
        to: '/categories',
        icon: <CIcon name="cil-list" customClasses="c-sidebar-nav-icon" />,
        initiativeMode: true,
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Registration Forms',
        to: '/registration-forms',
        icon: <CIcon name="cil-list-numbered" customClasses="c-sidebar-nav-icon" />,
        initiativeMode: true,
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'View Donations',
        to: '/donations',
        icon: <CIcon name="cil-dollar" customClasses="c-sidebar-nav-icon" />,
        permission: permissions.view_donations,
        adminMode: false,
        initiativeMode: true,
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'User Manual',
        to: '/manual',
        icon: <CIcon name="cil-list-rich" customClasses="c-sidebar-nav-icon" />,
        adminMode: true,
        initiativeMode: true,
      },
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'User Manual',
    to: '/manual',
    icon: <CIcon name="cil-list-rich" customClasses="c-sidebar-nav-icon" />,
    adminMode: false,
    initiativeMode: true,
    forbiddenInitiativeRoles: [
      roles.petitionImageViewer.name,
      roles.petitionUploader.name,
      roles.reportViewer.name,
      roles.canvassingOrganizationUser.name,
      roles.electionOfficialAssignee.name,
      roles.electionOfficialAdmin.name,
    ],
    permission: permissions.view_manual_in_sidebar,
  },
];
